import { combineReducers } from "redux";
import commonReducer from "../../../../Common/Reducers/commonReducer";
import drivingMarketParamsReducer from "../drivingMarketsParams";
import HighestGainer from "./highestGainer";
export default combineReducers({
    reducersData: HighestGainer,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
